import React from 'react';
import PricingForm from './PricingForm';
import PricingHeader from './PricingHeader';
import styles from './DefaultPricing.module.css';

const DefaultPricing = () => (
  <div className={styles['default-pricing']}>
    <PricingHeader />
    <PricingForm />
  </div>
);

export default DefaultPricing;
